import { Serializable } from '../../core/models/serializable';
import { EducationalProgramModel } from '@admin/shared/models/educational-program-model';

export class EducationalInstitutionModel
  implements Serializable<EducationalInstitutionModel>
{
  fromObject(object: any): EducationalInstitutionModel {
    Object.assign(this, object);
    return this;
  }
  toObject() {
    throw new Error('Method not implemented.');
  }

  public educationalInstitutionId: number;
  public code: string;
  public name: string;
  public nameLatin: string;
  public logoFilename: string;
  public createDate: Date;
  public startDate: Date;
  public endDate: Date;
  public isActive: boolean;

  public programs: EducationalProgramModel[];
}
